import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {aboutData.title}
          </h2>
        </div>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutData.intro}
          </p>
        </div>
      </div>
    </section>
  );
}